import { FC } from 'react';
import Modal from 'react-modal';
import useAutoLogoff from '../../hooks/useAutoLogoff';
import styles from './ElmerModalAlert.module.scss';

type Props = {
  isModalOpen: boolean;
  closeModal: () => void;
};

Modal.setAppElement('#root');

const AutoLogoffModal: FC<Props> = ({ isModalOpen, closeModal }) => {
  const { onClickClose } = useAutoLogoff();

  return (
    <>
      <Modal
        className={styles['elmer-alert-dialog']}
        overlayClassName={styles.overlay}
        isOpen={isModalOpen}
      >
        <div className={styles['elmer-alert-dialog-container']}>
          <div className={styles['elmer-alert-dialog-header']}>
            <div className={styles['elmer-alert-dialog-header-left']}>
              <p>ライセンス認証の解除</p>
            </div>
          </div>
          <div className={styles['elmer-alert-dialog-content']}>
            <div className={styles['content-primary']}>
              <p>
                ライセンス認証の上限を超えたため、この端末のライセンス認証を解除しました。
              </p>
            </div>
          </div>
          <div
            className={`${styles['elmer-alert-buttons']} ${styles['mod-right']}`}
          >
            <button
              type="button"
              onClick={() => {
                closeModal();
                onClickClose();
              }}
              className={`${styles['elmer-alert-dialog-button']} ${styles['mod-horizontal']}`}
            >
              閉じる
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default AutoLogoffModal;
